module.exports = __webpack_public_path__ + "img/Wp_2064.45b7d6ad.png";